import { article as articleData } from "~/data";

export const checkIsMorningStudioArticle = (
  sponsorType: string | null,
  articleTypeIds: OrUndefined<string>[],
) => {
  const hasSponsorType = sponsorType !== null;
  const hasMorningStudio =
    articleTypeIds?.some(id => id === articleData.types.studio.entityId) ?? false;
  return hasSponsorType && hasMorningStudio;
};
